var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0051 0C26.39 0 34.0102 7.60996 34.0102 17.0051C34.0102 26.39 26.4002 34.0102 17.0051 34.0102C7.62016 34.0102 0 26.4002 0 17.0051C0 7.62016 7.60996 0 17.0051 0ZM13.0267 7.67117H20.9835C23.9724 7.67117 26.4104 10.0888 26.4104 13.0267V20.9631C26.4104 23.9112 23.9724 26.3186 20.9835 26.3186H13.0267C10.0378 26.3186 7.59976 23.9112 7.59976 20.9631V13.0267C7.59976 10.0786 10.048 7.67117 13.0267 7.67117ZM16.9541 11.9658C19.8614 11.9658 22.2178 14.3222 22.2178 17.2295C22.2178 20.1368 19.8614 22.4932 16.9541 22.4932C14.0468 22.4932 11.6904 20.1368 11.6904 17.2295C11.6904 14.3222 14.0468 11.9658 16.9541 11.9658ZM16.9541 13.7408C18.8719 13.7408 20.4326 15.3015 20.4326 17.2193C20.4326 19.1371 18.8719 20.6979 16.9541 20.6979C15.0261 20.6979 13.4755 19.1371 13.4755 17.2193C13.4755 15.3015 15.0363 13.7408 16.9541 13.7408ZM22.0444 11.2313C22.5137 11.2313 22.9013 11.6088 22.9013 12.0882C22.9013 12.5575 22.5239 12.9451 22.0444 12.9451C21.5752 12.9451 21.1875 12.5677 21.1875 12.0882C21.1875 11.619 21.565 11.2313 22.0444 11.2313ZM13.6796 9.19112H20.3306C22.8299 9.19112 24.8701 11.2211 24.8701 13.7102V20.402C24.8701 22.8911 22.8299 24.9211 20.3306 24.9211H13.6796C11.1803 24.9211 9.14011 22.8911 9.14011 20.402V13.7102C9.14011 11.2211 11.1803 9.19112 13.6796 9.19112Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fcc40750652f2937786b72bf97b2e4ad.svg";
export { ForwardRef as ReactComponent };